import React, { useMemo } from "react";
import PropTypes from "prop-types";

export const Title = ({ className, children, variant, size, style }) => {
  const classes = useMemo(() => {
    const collection = ["Title"];

    if (size) {
      collection.push(`Title--${size} Title--${variant}`);
    }

    if (className) {
      collection.push(className);
    }

    return collection.join(" ");
  }, [size, className]);

  switch (variant) {
    case "h1":
      return (
        <h1 className={classes} style={style}>
          {children}
        </h1>
      );
    case "h2":
      return (
        <h2 className={classes} style={style}>
          {children}
        </h2>
      );
    case "h3":
      return (
        <h3 className={classes} style={style}>
          {children}
        </h3>
      );
    case "h4":
      return (
        <h4 className={classes} style={style}>
          {children}
        </h4>
      );
    case "h5":
      return (
        <h5 className={classes} style={style}>
          {children}
        </h5>
      );
    case "h6":
      return (
        <h6 className={classes} style={style}>
          {children}
        </h6>
      );
    default:
      return (
        <h1 className={classes} style={style}>
          {children}
        </h1>
      );
  }
};

Title.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  size: PropTypes.oneOf([
    "default",
    "xs",
    "sm",
    "lg",
    "xl",
    "xxl",
    "overtitle",
  ]),
  style: PropTypes.object,
};

Title.defaultProps = {
  className: undefined,
  variant: "h1",
  size: "default",
  style: undefined,
};
